import { User } from "../User";
import { UserPermissions } from "../../../APIDocs/apiTypes";

export const useUser = (): User => {
    return User.GetUser();
}
export const useCanAccess = (permission: keyof UserPermissions): boolean => {
    return useUser().canAccess(permission);
}
export const useStoreUserPermissions = (permissions: UserPermissions | undefined) => {
    useUser().storeUserPermissions(permissions);
}
export const useGetUserType = (): string | undefined => {
    return useUser().getUserType();
}
export const useIsInternalUser = (): boolean => {
    return useUser().isInternalUser();
}
export const useIsSupplierUser = (): boolean => {
    return useUser().isSupplierUser();
}
